
















































import { Component, Prop, Emit, Watch } from "vue-property-decorator";
import CardModalAlergiObat from "@/components/modal/CardModalAlergiObat.vue";
import Vue from "vue";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import SvcAlergiObat from "@/services/AlergiObat";
import { appModule } from "@/store/modules/app";

@Component({
  components: {
    CardModalAlergiObat,
    ModalKonfirmasi
  }
})
export default class AlergiRekonsiliasiCard extends Vue {
  @Prop() readonly register;
  @Prop() readonly rm;
  @Prop() readonly disabled!: boolean;
  @Prop() readonly listAlergi: Array<any>;
  @Prop() loading: boolean;

  dialogAlergi = false;
  alergiObat = {};
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  itemHapus = null;

  get headersAlergi() {
    const base: any = [
      { text: "Nama Alergi/ES Obat", value: "kfa.nama" },
      { text: "Reaksi yang ditimbulkan", value: "reaksi" }
    ];
    if (!this.disabled) {
      base.push({
        text: "Aksi",
        value: "aksi",
        sortable: false,
        align: "center"
      });
    }
    return base;
  }

  tambahAlergi() {
    this.alergiObat = {
      id: null,
      pasien_rm: this.rm,
      kfa_id: null,
      reaksi: null,
      user_id: null,
      kfa: null
    };
    this.dialogAlergi = true;
  }

  editAlergi(item) {
    this.dialogAlergi = true;
    this.alergiObat = item;
  }

  hapus() {
    SvcAlergiObat.destroy(this.itemHapus.id)
      .then(resp => {
        if (resp.status === 1) {
          appModule.NoticeDelay("Berhasil menghapus alergi obat");
          this.$emit("reload");
        } else {
          appModule.sendErrorAlert(resp.message);
        }
      })
      .finally(() => {});
  }

  konfirmHapus(item) {
    this.itemHapus = null;
    this.itemHapus = item;
    this.msgConfirm = `Anda yakin ingin hapus alergi obat : ${this.itemHapus.kfa.nama}?`;
    this.modalOpenKonfirmasi = true;
  }
}
